import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { FormaDistribuicaoLancamento } from "features/previsao-orcamentaria/typings";
export interface SelectFormaDistribuicaoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  filterOptions?: number[];
}

function SelectFormaDistribuicao({
  value,
  filterOptions = [],
  ...rest
}: SelectFormaDistribuicaoProps) {
  const options = [
    {
      label: "Dividido entre meses",
      value: FormaDistribuicaoLancamento.DivididoEntreMeses,
    },
    {
      label: "Igual todos meses",
      value: FormaDistribuicaoLancamento.IgualTodosMeses,
    },
  ];

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options.filter(
        (option) => !filterOptions.includes(Number(option.value))
      )}
      {...rest}
    />
  );
}

export default SelectFormaDistribuicao;
